import type { ExtendedMedicationRequest } from '#src/models/medicationRequest.ts'

// Name-based on purpose: vaccines entered without an RxNorm code still match,
// and Elation's permanence flag is unreliable for vaccines. The brand list was
// checked against NIH RxClass CVX membership for every active RxNorm code in
// prod. `ipol` and `vaccine` are word-bounded so they cannot match inside or at
// the start of a longer name. Keep generic substrings like `flu` or `zos` out:
// they hit fluoxetine and fluticasone.
export const VACCINE_NAME_PATTERN =
  /engerix|shingrix|prevnar|pneumovax|fluarix|fluzone|afluria|flublok|flucelvax|fluad|flumist|heplisav|havrix|boostrix|adacel|arexvy|abrysvo|gardasil|twinrix|vaqta|comirnaty|spikevax|novavax|menquadfi|menveo|bexsero|trumenba|tenivac|recombivax|vaxneuvance|capvaxive|mresvia|zostavax|varivax|\bipol\b|\bvaccine\b/i

export function isVaccineMedicationName(name: string | undefined): boolean {
  return name !== undefined && VACCINE_NAME_PATTERN.test(name)
}

export function isVaccineMedication(med: ExtendedMedicationRequest): boolean {
  return isVaccineMedicationName(med.medicationName)
}
